import Button from "../../components/Shared/Button"
import TeamMemberCard from "../../components/Dashboard/Teams/TeamMemberCard"
import AddIcon from "../../components/Icons/AddIcon"
import { useState } from "react"
import { useQuery } from "@tanstack/react-query"
import AddNewMember from "../../components/Dashboard/Teams/AddNewMember"
import { GetAllTeam } from "../../api/Team/GetAllTeam"
import DashboardInlineBackButton from "../../components/Dashboard/Shared/DashboardInlineBackButton"
const Team = () => {
    const [showAddMember, setShowAddMember] = useState(false);
    const { data: TeamDTO } = useQuery({
        queryFn: GetAllTeam,
        queryKey: ["teams"],
        staleTime: 0,
        refetchInterval: 0,
    });
    const handleAddMemberSuccess = () => {
        setShowAddMember(false);
      };
    
    const team = TeamDTO?.data
    return (
        <div>
            {showAddMember ? (
                <div className="space-y-4">
                    <DashboardInlineBackButton
                        label="Back to team"
                        onClick={() => setShowAddMember(false)}
                    />
                    <AddNewMember onSuccess={handleAddMemberSuccess} />
                </div>
            ) : (

                <div>
                    <div className="flex justify-between items-center py-7">
                        <h1 className="text-burntBlack font-bold text-[32px]">Team</h1>
                        <Button
                            onClick={() => setShowAddMember(true)}
                            className="!h-12 w-44 !text-sm font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
                            variant="primary"
                        >
                            <AddIcon className="mr-1.5" />
                            Add New Member
                        </Button>
                    </div>
                    <div className="grid grid-cols-4 gap-7">
                        {team?.map((Team) => (
                            <TeamMemberCard teamId={Team.id} img={Team.img_url} title={Team.title} name={Team.name} email={Team.email} />
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default Team
